import { useState } from 'react';
import { read_cookie } from "sfcookies";
import { hostUrl, UseUrlManagerCleanUrl } from "../../../../../utils/url-manager";
import { Identifier } from 'react-admin';
import { EmailFinder } from "../../../../../../types/entities";

type CreateFinderProps = {
    creatingEmailFinder: boolean,
    emailFinder: any,
    createEmailFinder: (
        name: string,
        targetUrl: string,
        adminUserId: Identifier | undefined,
        quickScan: boolean
    ) => Promise<void>,
}

export const useCreateEmailFinder: () => CreateFinderProps = (): CreateFinderProps => {
    const [creatingEmailFinder, setCreatingEmailFinder] = useState<boolean>(false);
    const [emailFinder, setEmailFinder] = useState<any>();

    async function createEmailFinder(
        name: string,
        targetUrl: string,
        adminUserId: Identifier | undefined,
        quickScan: boolean = false
    ): Promise<any> {
        setCreatingEmailFinder(true);
        let token: string = read_cookie('auth');
        let url: string = hostUrl + 'hq/email-finder/admin/create';
        url = UseUrlManagerCleanUrl({ url: url });
        const payload = {
            'name': name,
            'targetUrl': targetUrl,
            'adminUserId': adminUserId,
            'quickScan': quickScan,
        };
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json();
            })
            .then( (data: any): void => {
                if (data !== undefined && data['status'] === 'success') {
                    setEmailFinder(data.data)
                }
            })
            .catch( (error: Error): void => {
                console.log(error);
            })
            // The old code cleared this flag only on the success branch, so a
            // refused create left both buttons spinning until the tab was left.
            // `refresh()` went with it: the container reloads its own list now,
            // and a react-admin refresh threw away unsaved edits on the mini's
            // other tabs.
            .finally( (): void => {
                setCreatingEmailFinder(false);
            })
    }

    return { creatingEmailFinder, createEmailFinder, emailFinder };
}


type FinderListProps = {
    emailFinders: EmailFinder[],
    loadingFinders: boolean,
    totalFinders: number,
    loadEmailFinders: any,
    finderError: string
}

export const useGetFinderList: () => FinderListProps = (): FinderListProps => {
    const [emailFinders, setEmailFinders] = useState<EmailFinder[]>([]);
    const [loadingFinders, setLoadingFinders] = useState<boolean>(false);
    const [totalFinders, setTotalFinders] = useState<number>(0);
    const [finderError, setFinderError] = useState<string>('');

    function loadEmailFinders(adminId: string|number,
                              searchTerm: string|undefined,
                              page: number): void {
        setLoadingFinders(true);
        let token: string = read_cookie('auth');
        let url: string = hostUrl + 'hq/email-finder/admin/list';
        url = UseUrlManagerCleanUrl({ url: url });
        const payload = {
            'adminId': adminId,
            'searchTerm': searchTerm,
            'page': page,
        };
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json();
            })
            .then( (data: any): void => {
                if (data !== undefined && data['status'] === 'success') {
                    setEmailFinders(data.data.items);
                    setTotalFinders(data.data.total);
                    // Without this a single failed load left the pane reading
                    // an error for the rest of the session.
                    setFinderError('');
                }
                if (data !== undefined && data['status'] === 'error') {
                    setFinderError(data['message']);
                }
            })
            .catch( (error: Error): void => {
                console.log(error);
                setFinderError('The scan list could not be loaded.');
            })
            .finally( (): void => {
                setLoadingFinders(false);
            })
    }


    return { emailFinders, loadingFinders, totalFinders, loadEmailFinders, finderError }
}
